import CustomDateTime from "app/Components/DateTimeCustom/CustomDateTime";
import MultiSelectWithCheckbox from "app/Components/SearchableSelect/MultiSelectCkeckOption";
import MultiSelectTwo from "app/Components/SearchableSelect/MultiSelectTwo";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import { YYYYMMDDFormat } from "app/_helpers/dateHelper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";

function MMInvestigationForm({ form, onChange, setForm, errorForm, users }) {
  return (
    <Row>
      {/* <Col lg={12}>
          <label className="checkbox checkbox-primary">
            <input
              type="checkbox"
              checked={form.isInvestigation}
              name="isInvestigation"
              onChange={onChange}
            />
            <span>Do you want to request investigation. </span>
            <span className="checkmark" />
          </label>
          <span className="small text-danger">{errorForm.isInvestigation}</span>
        </Col> */}
      <Col lg={4}>
        <div className="form-group mb-3">
          <FormSelect
            label={"Investigation Leader"}
            name="investigationLeader"
            value={form?.investigationLeader}
            onChange={onChange}
            options={users?.filter(d => d.email_verify === 1).map((user) => ({ ...user, label: userDropdownLabel(user) }))}
            error={errorForm?.investigationLeader}
            KEY_label={"label"}
            KEY_value={"id"}
            blankSelect={"Select"}
          ></FormSelect>
        </div>
      </Col>
      <Col lg={4}>
        <div className="form-group mb-3">
          <label>Investigation Members</label>
          <MultiSelectTwo
            options={users
              .filter((d) => d.id !== +form?.investigationLeader)
              .map((user) => ({
                label: userDropdownLabel(user),
                value: user,
                disabled:
                  form?.investigationMember?.split(",")?.length === 3 &&
                    form?.investigationMember?.split(", ")?.includes(user.id.toString())
                    ? false
                    : form?.investigationMember?.split(",")?.length < 3 ||
                      !form?.investigationMember
                      ? false
                      : true,
              }))}
            value={(form.investigationMember || "")
              .split(",")
              .map((id) => {
                const found = users.find((role) => role.id === +id);

                return found
                  ? {
                    label: userDropdownLabel(found),
                    value: found,
                  }
                  : null;
              })
              .filter((d) => !!d)}
            onChange={(selectUser) => {
              setForm((prevForm) => ({
                ...prevForm,
                investigationMember: selectUser
                  ?.map((userId) => userId.value.id)
                  .join(", "),
              }));
            }}
            hasSelectAll={false}
            disableSearch={false}
          />

          {/* <span className="small text-danger">
          {errorForm?.targetCompletionDate}
        </span> */}
        </div>
      </Col>
      <Col lg={4}>
        <div className="form-group mb-3">
          <label>Target Completion Date</label>
          <div className="calenderFixed">
            <CustomDateTime
              name="targetCompletionDate"
              value={form.targetCompletionDate}
              isValidDate={(day) =>
                // day.isSameOrBefore(moment()) &&
                day.isSameOrAfter(YYYYMMDDFormat(form?.incidentDate))
              }
              onChange={(moment, name) =>
                onChange({
                  target: {
                    name,
                    value: moment.format("YYYY-MM-DD"),
                  },
                })
              }
              readOnly
            />
          </div>
          {/* <span className="small text-danger">
          {errorForm?.targetCompletionDate}
        </span> */}
        </div>
      </Col>
      {form?.investigationMember && (
        <Col md="12">
          <div className="form-group">
            <label>Investigation Members</label>

            <div className="teamSection">
              {form?.investigationMember?.split(",")?.map((id) => {
                const found = users.find((site) => site.id === +id);
                return (
                  <>
                    {found && (
                      <span className="position-relative emp-section">
                        <span className="empTab">{userDropdownLabel(found)}</span>
                        {
                          <span
                            className="icons text-danger"
                            onClick={(e) => {
                              onChange({
                                target: {
                                  name: "investigationMember",
                                  value: form?.investigationMember
                                    ?.split(",")
                                    ?.filter((id) => +id !== found?.id)
                                    .join(","),
                                },
                              });
                            }}
                          >
                            <FaTimes />
                          </span>
                        }
                      </span>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        </Col>
      )}
    </Row>
  );
}

export default MMInvestigationForm;
